<template>
  <div>
    <v-dialog
      v-model="planDialog"
      width="410px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <span>Set Manual Discount/Admin Charge</span>
            <i
              class="el-icon-close"
              @click="changeDialog"></i>
          </div>
        </div>
        <div class="dialog-body">
          <div class="flex-content">
            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <span>{{ item.item }}</span>
                <!--                <span>{{ item.premium | formatMoney(2, true) }}</span>-->
                <span>{{ item.premium | formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="isRenew"
                class="flex-info ">
                <span>Renew Discount {{is_renew_discount?`(${form.renew_disc_pct}%)`:''}}</span>
                <span>
                  <span
                    v-if="is_renew_discount"
                    class="mg-l-8">-{{form.renew_disc_prm | formatMoney(2, true)}}</span>
                  <span class="mg-l-8">{{is_renew_discount?'On':'Off'}}</span>
                  <el-switch
                    v-model="is_renew_discount"
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="is_renew_disable "
                    :active-color="'#DDF4FF'"
                    :inactive-color="'#EAEEF2'"
                    @change="computedDiscount"
                  >
                  </el-switch>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>MGM Discount</span>
                <span>
                  <v-input
                    v-model="code_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Manual Discount</span>
                <span>
                  <v-input
                    v-model="spec_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Admin Charge</span>
                <span>
                  <v-input
                    v-model="handling_fee"
                    :keyFloatNumber="true"
                    prepend="+ $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
              </div>
            </div>
          </div>
          <code-select
            v-if="isShowCode"
            ref="codeForm"
            :orderId="orderId"
            :notApply="true"
            :isQuote="false"
            :customerId="customer_id"
            :customer="customer"
            is-referral-option
            :isGuest="isGuest"
            :isRenew="isRenew"
            :is-user="true"
            @handlerSelectCoupon="handlerSelectCoupon"
            @handlerCoupon="handlerCoupon"
            @check-code="applyCode"
          ></code-select>
          <div
            v-if="showReferralSelect&&!isRenew"
            class="mg-t-20 flex">
            <!--            <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>-->
            <v-select
              v-model="referral_id"
              :list="referral_option_list"
              @change="computedReferDiscount"></v-select>
            <v-button
              gray
              class="mg-l-10"
              @click="handleInitRefer">Default</v-button>
          </div>
        </div>
        <div class="flex footer-button">
          <v-button @click="changeDialog">Close</v-button>
          <v-button
            type="success"
            @click="ConfirmCoupon">Save</v-button>
        </div>
      </div>
      <coupon-dialog
        ref="coupon-dialog"
        :customerId="customer_id"
        :orderId="orderId"
        :isQuote="false"
        :classId="classId"
        :class="{'has-append-body':true}"
        :customer="customer"
        @coupon="computedCoupon">
      </coupon-dialog>
    </v-dialog>
    <div>
      <attach-customer
        ref="attachCustomer"
        @handlerSelectCustomer="handlerSelectCoupon"></attach-customer>

    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinReferralOption from '@/mixins/referral-option'
import {setQuoteDiscount} from '@/api/order'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import CouponDialog from '@/views/quoting/dialogs/coupon-dialog'
import CodeSelect from '@/views/components/code-select'

export default {
  name: 'setManualDialog',
  components: {
    // selectDiscountFuc,
    attachCustomer,
    CouponDialog,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat,MixinReferralOption],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId:{
      type:[String,Number],
      default:''
    },
    isAmount:{
      default:false,
      type:Boolean,

    },
    isShowCode: {
      type: Boolean,
      default: true
    },
    isSme:{
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      planDialog: false,
      coupon:'',
      amount:'',
      spec_disc_prm:'',
      code_disc_prm:'',
      handling_fee:'',
      formData:{},
      modal:false,
      is_renew_discount:0
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('coupon', ['selectCode']),
    customer() {
      let {isrd_nm} = this.form || {}
      return {
        isrd_nm,
        appendToBody:true
      }
    },
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    customer_id(){
      let {customer_id} = this.form||{}
      return customer_id||''
    },
    classId() {
      return this.form.class_id || 14
    },
    premium_info(){
      let {sidebar_info} = this.form||{}
      let {premium_info=[]} =sidebar_info||{}
      if(this.isNewSME){
        return  sidebar_info
      }
      return premium_info||[]
    },
    sidebarPremium() {
      let coverageList
      if(this.isSme){
        coverageList =this.premium_info
      }else {
        let {sidebar_premium} = this.form.quote_coverage_list||{}
        coverageList = sidebar_premium
      }
      if(!coverageList) {
        return []
      }
      let {spec_disc_prm,handling_fee,sidebar_info={},code_disc_prm} = this.form
      this.spec_disc_prm = spec_disc_prm
      this.handling_fee  =handling_fee
      this.code_disc_prm = code_disc_prm
      if(this.isSme){
        this.spec_disc_prm = sidebar_info.spec_disc_prm||0
        this.handling_fee  =sidebar_info.handling_fee||0
      }
      let premium = coverageList.filter(item => item.name != 'paid'&&item.name!='handling_fee'&&item.name!='spec_disc_prm')

      return premium
    },
    maxPrice(){
      let {spec_disc_prm}= this.form
      let num = (spec_disc_prm+this.amount).toFixed(2)
      return Number(num)
    },
    discountPrice(){
      // let {quote_coverage_list} = this.form||{}
      // let {sidebar_premium={}} = quote_coverage_list
      // let premum = sidebar_premium.filter(item => item.name == 'code_disc_prm'||item.name=='coupon')
      let {coupon_vl=0,code_disc_prm=0,promo_disc_prm=0} = this.form||{}
      return Number(coupon_vl||0) + Number(code_disc_prm||0)+Number(promo_disc_prm||0)
    },
    amountResult() {
      // if(this.isAmount)
      //   return  this.amount
      // else
      //   return Number(this.amount) - Number(this.spec_disc_prm) + Number(this.handling_fee) - this.discountPrice
      let amount = 0
      if(this.form.quote_coverage_list){
        this.form.quote_coverage_list.sidebar_premium.map(item => {
          if(item.name == 'paid'){
            amount = item.premium
          }
        })
      }
      return this.isSme?Number(this.form.amount):amount
    },
    isGuest(){
      return this.form.is_share_guest_order == 1
    },
    isRenew(){
      // return  false
      return this.form.type == 20
    },
    is_renew_disable(){
      // return  false
      let {is_renew_disable=0} = this.form
      return is_renew_disable==1
    },
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        // this.amount = val.amount
        const {referrer, referrer_user_id} = val
        this.amount = this.isSme?Number(val.amount):val.gross
        let {code_disc_prm,code,coupon_code,sidebar_info={},renew_disc_pct=0,is_renew_discount,renew_disc_rate,campaign_code} = val||{}
        let useCode = this.isSme&&!this.isNewSME?sidebar_info.code:code
        let use_coupon_code = this.isSme&&!this.isNewSME?sidebar_info.coupon_code:coupon_code
        this.renew_disc_pct = renew_disc_pct
        this.code_disc_prm = code_disc_prm
        this.is_renew_discount = is_renew_discount
        let params = {}
        if(useCode)
        {
          params.code = {
            selectCode: 2,
            code: useCode||'',
            referrer,
            referrer_user_id
          }
        }
        if(use_coupon_code)
          params.coupon = {selectCode: 1, title:use_coupon_code,coupon_code:use_coupon_code}
        if(campaign_code)
        {
          params.code= {selectCode: 2, code:campaign_code}
          params.is_campaign_code = 1
        }
        this.setSelectCode(params)
        // if(this.isRenew&&code){
        //   this.mixinNetwork().getOrderReferralList()
        // }
      }
    },
  },
  methods: {
    ...mapActions('coupon', ['setSelectCode', 'setCouponData']),
    handleInitRefer(){
      if(!this.isRenew)
        this.initReferrerId()
      this.computedReferDiscount()
    },
    handlerCoupon() {
      if (!this.customer_id) {
        this.$refs.attachCustomer.showAttachCustomer()
      } else {
        this.$refs['coupon-dialog'].changeDialog()
      }
    },
    handlerSelectCoupon() {
      this.$refs['coupon-dialog'].changeDialog()
    },
    computedCoupon(data) {
      let { coupon_code} = data||{}
      let params = this.selectCode||{}
      this.setSelectCode(null)
      if (coupon_code) {
        this.coupon = data
        params.coupon = {selectCode: 1, ...data}
        this.setCouponData(data.coupon_code)
      }else{
        params.coupon = null
        this.setCouponData(null)
      }
      this.setSelectCode(params)
      this.network().setQuoteDiscount()
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      this.planDialog =false
      this.network().setQuoteDiscount({send:true})
    },
    applyCode(code) {
      this.network().setQuoteDiscount()
    },
    computedDiscount() {
      this.network().setQuoteDiscount()
    },
    computedReferDiscount(){
      this.network().setQuoteDiscount({},true)
    },
    network() {
      return {
        setQuoteDiscount: async (params,isRefer=false) => {
          params = {...params}
          let {coupon, code,is_campaign_code} = this.selectCode || {}
          let {coupon_code}  = coupon||{}
          params.coupon_code = coupon_code
          params.code =code&&code.code
          if(this.isRenew){
            params.is_renew_discount = this.is_renew_discount
          }
          // if(isRefer){
          if(!this.isRenew){
            params = {
              ...params,
              ...this.code_discount_info
            }
          }
          if(is_campaign_code){
            params.campaign_code = code.code
            delete params.code
          }
          // }
          const {data} = await setQuoteDiscount({
            order_id: this.orderId,
            spec_disc_prm:this.spec_disc_prm,
            handling_fee:this.handling_fee,
            code_disc_prm:this.code_disc_prm,
            ...params,
          })
          // if(params.code){
          let {campaign_code} = params||{}
          if(!this.isRenew)
            this.mixinNetwork().getOrderReferralList({code:params&&params.code||campaign_code||''})
          // }
          this.$emit('saveManual',params.send)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
    justify-content: space-between;
  }
  .flex-content {
    //width: 280px;
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;
        .mg-l-8{
          margin-right: 8px;
          font-weight: 400!important;
          font-size: 12px!important;
          line-height: 18px;
          color: #24292E!important;
        }
        /deep/ .el-switch{
          .el-switch__core{
            border-radius: 6px;
            border: 1px solid #AFB8C1;
            &:after{
              top: 0;
              border-radius: 6px;
              background: #F6F8FA;
              border: 1px solid #AFB8C1;
            }
            &:before{
              content: 'O';
              position: absolute;
              right: 5px;
            }
          }
          &.is-checked{
            .el-switch__core{
              border: 1px solid #54AEF4;
              &:after{
                background: #0366D6;
              }
              &:before{
                content: 'I';
                left: 10px;
                position: absolute;
              }
            }
          }

        }
        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
    .coupon-button{
      .el-button{
        width: 100%;
      }
      .margin-right{
        margin-right: 10px;
      }
    }
    .coupon-data{
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      padding: 16px;
      .coupon-title{
        color: #24292E;
        font-size: 16px;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .coupon-des{
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        font-size: 12px;
        margin-top: 8px;
        -webkit-box-orient: vertical;
        color: #586069;
      }
    }
  }
}
</style>
